// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/**
 * Warehouse page routes (warehouse-transfers-and-assignment wp-12).
 *
 * Every permission code below was verified against `app_permissions` on
 * 2026-08-20 — the live menu's `warehouses.read` matches nothing, and that
 * exact mistake is why each guard here names a code the wp-01 migration
 * actually inserted. Create keeps the live PLURAL segment
 * (`access.inventory.warehouses.create-warehouse`); the rest use wp-01's
 * singular segment. Archived warehouse reads reuse the search code, per the
 * wp-05 decision.
 *
 * Wired into `./index.js` by wp-13, when its pages landed. The stock transfer
 * routes live in `./warehouse-transfers.js`, still unwired, because their
 * wp-27 pages do not exist yet and Vite refuses to transform an unresolvable
 * dynamic import.
 */
export default [
    {
        path: '/:organisation/inventory/warehouses/stock',
        component: () =>
            import('@/pages/[organisation]/inventory/warehouses/stock.vue'),
        name: 'inventory.warehouses.view-warehouse-stock',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.warehouse-stock.view-warehouse-stock',
        },
    },
    {
        path: '/:organisation/inventory/warehouses',
        component: () =>
            import('@/pages/[organisation]/inventory/warehouses/index.vue'),
        name: 'inventory.warehouses.search-warehouses',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.warehouse.search-warehouse',
        },
        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/warehouses/create-warehouse.vue'),
                name: 'inventory.warehouses.create-warehouse',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.warehouses.create-warehouse',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/warehouses/[id].vue'),
                name: 'inventory.warehouses.view-warehouse',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.warehouse.view-warehouse',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/warehouses/[id]/edit.vue'),
                name: 'inventory.warehouses.update-warehouse',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.warehouse.update-warehouse',
                },
            },
        ],
    },
];
